import { createAsyncThunk } from '@reduxjs/toolkit';
import portalApi from '../../core/api/portal.api';
import { Site, SiteResponse, GraphQlError } from '../../core/types/common.types';

export const getSiteThunk = createAsyncThunk<
  // Return type of the payload creator
  Site,
  // First argument to the payload creator
  string,
  // Types for ThunkAPI
  {
    extra: {
      jwt: string;
    };
    rejectValue: GraphQlError[];
  }
>('site/getSiteThunk', async (id, thunkApi) => {
  const response: SiteResponse = await portalApi.getSite(id);
  const errors = response.errors;
  const participant = response.data?.getSite;
  console.log('TESTING', response);
  if (errors) {
    return thunkApi.rejectWithValue(errors);
  }
  return participant as Site;
});
